if (!customElements.get('header-megamenu')) {
  class HeaderMegamenu extends HTMLElement {
    constructor() {
      super();
      this.megamenuSelectors = {
        megamenu: '[megamenu-opener]',
        content: '[megamenu-content]',
        button: '[megamenu-btn]'
      };
      this.megamenu = this.querySelectorAll(this.megamenuSelectors.megamenu);
      this.initEventListeners();
    }

    initEventListeners() {
      this.megamenu.forEach(menu => {
        menu.addEventListener('mouseenter', this.handleMouseEnter.bind(this, menu));
        menu.addEventListener('mouseleave', this.handleMouseLeave.bind(this, menu));
      });
    }

handleMouseEnter(menu) {
  clearTimeout(this._leaveTimer);

  // Close all other open menus immediately
  this.megamenu.forEach(otherMenu => {
    if (otherMenu !== menu) {
      const otherBtn = otherMenu.querySelector(this.megamenuSelectors.button);
      if (otherBtn && otherBtn.getAttribute('aria-expanded') === 'true') {
        otherBtn.click();
      }
    }
  });

  const megamenuBtn = menu.querySelector(this.megamenuSelectors.button);
  if (megamenuBtn) {
    const expanded = megamenuBtn.getAttribute('aria-expanded');
    if (expanded === 'false') {
      megamenuBtn.click();
    }
  }
}


handleMouseLeave(menu) {
  const megamenuInner = menu.querySelector(this.megamenuSelectors.content);
  const megamenuBtn = menu.querySelector(this.megamenuSelectors.button);
  if (megamenuInner && megamenuBtn) {
    this._leaveTimer = setTimeout(() => {
      const expanded = megamenuBtn.getAttribute('aria-expanded');
      if (expanded === 'true') {
        megamenuBtn.click();
      }
    }, 250);
  }
}
  }

  customElements.define('header-megamenu', HeaderMegamenu);
}

// class HeaderMegamenu extends HTMLElement {
//   constructor() {
//     super();
//     this.megamenuSelectors = {
//       megamenu: '[megamenu-opener]'
//     }
//     this.prevMenu = '';
//     this.megamenu = this.querySelectorAll(this.megamenuSelectors.megamenu);
//     this.megamenu.forEach(menu => {
//       menu.addEventListener('mouseenter', (e) => {
//         const megamenuInner = menu?.querySelector('[megamenu-content]');
//         const megamenuBtn = menu?.querySelector('[megamenu-btn]');
//         if (megamenuInner && megamenuBtn) {
//           megamenuBtn.click();
//         }
//       });
//       menu.addEventListener('mouseleave', (e) => {
//         const megamenuInner = menu?.querySelector('[megamenu-content]');
//         const megamenuBtn = menu?.querySelector('[megamenu-btn]');
//         if (megamenuInner && megamenuBtn) {
//           const expanded = megamenuBtn.getAttribute('aria-expanded');
//           if (expanded === 'true') {
//             megamenuBtn.click();
//           }
//         }
//       });
//     });
//   }
// }

// customElements.define('header-megamenu', HeaderMegamenu);
